import React from 'react'
import UserCardsContainer from '../../../../Components/Applications/Users/UserCards'

export default function UserCards() {
  return (
    <div className='page-body'>
        <UserCardsContainer/>
    </div>
  )
}
